import { useState } from 'react';
import { useSessionContext } from './SessionContext.ts';

export function ResetForNewGroup() {
  const { client } = useSessionContext();
  const [confirming, setConfirming] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function reset() {
    setResetting(true);
    setError(null);
    try {
      const outcome = await client.send('session.reset_for_group', {}, 'session');
      if (!outcome.ok) { setError(outcome.message); return; }
      setConfirming(false);
    } catch {
      setError('Connection interrupted. Reconnect before trying the reset again.');
    } finally { setResetting(false); }
  }

  if (!confirming) {
    return (
      <button type="button" className="button" onClick={() => { setError(null); setConfirming(true); }}>
        Reset for a new group
      </button>
    );
  }

  return (
    <div className="card stack-sm" role="group" aria-label="Reset for a new group">
      <strong>Start with a clean room?</strong>
      <p>Everyone else will be removed and the current invitation will stop working. You’ll stay as host in an empty lobby with a new link and QR code.</p>
      <div className="row">
        <button type="button" className="button button-danger" disabled={resetting} onClick={() => void reset()}>
          {resetting ? 'Resetting room…' : 'Reset room'}
        </button>
        <button type="button" className="button" disabled={resetting} onClick={() => setConfirming(false)}>
          Cancel
        </button>
      </div>
      {error ? <p className="badge badge-danger" role="alert">{error}</p> : null}
    </div>
  );
}
